module.exports = __webpack_public_path__ + "img/bright.802dd2b8.png";